// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useNotify} from "react-admin";
import * as React from "react";
import { Card, TextField, Button, } from '@material-ui/core';
import { getReserveList, changeStatusReserveDiet } from './index'
import { useForm } from "react-hook-form";
export const validateIranMobile = (value: string): boolean | string => {
    const regex = /^09\d{9}$/;
    if (value) {
        if (!regex.test(value)) {
            return "شماره موبایل صحیح نمیباشد";
        }
        return true;
    }
};

const ListComponent = ({ items , refreshList}) => {
    const notify = useNotify()
    const formatDate = (date) => {
        return new Intl.DateTimeFormat("fa-IR", {
            weekday: "long",
            year: "numeric",
            month: "numeric",
            day: "numeric",
        }).format(new Date(date));
    };
    const setEnable = async (itemIndex) => {
        setLoadingState(itemIndex, true);
        const params = { id: items[itemIndex].diets[0].id, status: "CREATED" }
        changeStatusReserveDiet(params).then((res) => {
            if (res.data.err) {
                console.log("err", res.data.err);
                if (res.data.err.code === 400 && res.data.err.message === "user-has-active-diet") {
                    
                    notify("کاربر رژیم فعال دارد", { type: 'error' })

                }else if(res.data.err.code === 400 && res.data.err.message === "invalid-reserved-diet"){
                    notify(" رژیم  رزرو  یافت نشد", { type: 'error' })

                }else if(res.data.err.code === 500){
                    notify(" ۵۰۰ خطای سرور  ", { type: 'error' })

                }else{
                    notify("خطایی پیش آمده است ", { type: 'error' })
                }   
                refreshList()
                setLoadingState(itemIndex, false)
            }
            else {
                if (res.data) {
                    console.log("res", res.data);
                    setLoadingState(itemIndex, false)
                    notify("با موفقیت انجام شد", { type: 'success' })
                    refreshList()
                }
            }
        }).catch((err) => {

            setLoadingState(itemIndex, false)
            notify("خطایی پیش آمده است ", { type: 'error' })
        })

    };
    const setDisable = async (itemIndex) => {
        setLoadingState2(itemIndex, true);
        const params = { id: items[itemIndex].diets[0].id, status: "CANCELLED" }
        changeStatusReserveDiet(params).then((res) => {
            if (res.data.err) {
                if (res.data.err.code === 400 && res.data.err.message === "user-has-active-diet") {
                    
                    notify("کاربر رژیم فعال دارد", { type: 'error' })

                }else if(res.data.err.code === 400 && res.data.err.message === "invalid-reserved-diet"){
                    notify(" رژیم  رزرو  یافت نشد", { type: 'error' })

                }else if(res.data.err.code === 500){
                    notify(" ۵۰۰ خطای سرور  ", { type: 'error' })

                }else{
                    notify("خطایی پیش آمده است ", { type: 'error' })
                }   
               
                setLoadingState2(itemIndex, false)
            }
            else {
                if (res.data) {
                    console.log("res", res.data);
                    setLoadingState2(itemIndex, false)
                    notify("با موفقیت انجام شد", { type: 'success' })
                    refreshList()
                }
            }
        }).catch((err) => {

            setLoadingState2(itemIndex, false)
            notify("خطایی پیش آمده است ", { type: 'error' })
        })

    };
    const [loadingStates, setLoadingStates] = React.useState(Array(items.length).fill(false));
    const [loadingStates2, setLoadingStates2] = React.useState(Array(items.length).fill(false));
    const setLoadingState = (index, value) => {
        setLoadingStates(prevStates => {
            const newStates = [...prevStates];
            newStates[index] = value;
            return newStates;
        });
    };
    const setLoadingState2 = (index, value) => {
        setLoadingStates2(prevStates => {
            const newStates = [...prevStates];
            newStates[index] = value;
            return newStates;
        });
    };
    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "1rem",
            width: "25%",
            direction: "rtl",
            fontFamily: "IranSans-Medium"
        }}>
            {items.map((item, index) => (
                <Card key={index} style={{ padding: "20px", position: 'relative' }}>
                    <div style={{ margin: "8px" }}>عنوان: <span style={{ color: "dimgray" }}>{item.meta.title} </span></div>
                    <div style={{ margin: "8px" }}>تاریخ ایجاد: <span style={{ color: "dimgray" }}> {item.createdAt ? formatDate(item.createdAt) : ''}</span></div>
                    <div style={{ margin: "8px" }}>تعداد دوره: <span style={{ color: "dimgray" }}> {item.dietCount}</span></div>
                    <div style={{ margin: "8px" }}>لیموپلاس: <span style={{ color: "dimgray" }}>{item.meta.withMentor ? 'دارد' : 'ندارد'}</span></div>
                    <Button disabled={loadingStates[index]} style={{ color: '#fff', marginTop: '10px' }} onClick={() => setEnable(index)} variant="contained" color="primary">
                        {loadingStates[index] ? 'در حال فعال‌سازی...' : 'فعال سازی'}
                    </Button>
                    <Button disabled={loadingStates2[index]} style={{ color: '#fff', marginTop: '10px', marginRight: "5px" }} onClick={() => setDisable(index)} variant="contained" color="secondary">
                        {loadingStates2[index] ? 'در حال غیرفعال سازی...' : 'غیر فعال سازی'}
                    </Button>
                </Card>
            ))}
        </div>
    );
};



export function ListReserveManagement() {
    interface IFormInput {
        mobile: string;
    }
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid },
    } = useForm<IFormInput>({
        mode: "onChange",
        defaultValues: {
            mobile: null,
        },
    });

    const [errorMessages, setErrorMessages] = React.useState([]);
    const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");
    const [reserveList, setReserveList] = React.useState([]);
    const [userMobile,setUserMobile] = React.useState("")
    const refreshList = () => {
        onSubmit({ mobile: userMobile });
    };
    const onSubmit = async (data: IFormInput) => {
        setReserveList([]);
        setErrorMessages([]);
        setNetworkState("PENDING");
        setUserMobile(data.mobile)
        const postData = {
            mobile: data.mobile,
        };

        getReserveList(postData).then((res) => {
            if (res.data.err) {
                setErrorMessages([res.data.err.details.messages[0]]);
                setNetworkState("FAILED");
            }
            else {
                if (res.data) {
                    setNetworkState("SUCCEED");
                    setReserveList(res.data)

                }
            }
        }).catch((err) => {
            console.log('err', err);
        })
    }

    return (
        <>
            <Card>

                <form
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                        margin: "3rem",
                        direction: "rtl",
                    }}
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <TextField
                        {...register("mobile", {
                        })}
                        error={!!errors.mobile}
                        helperText={errors.mobile ? errors.mobile.message : null}
                        fullWidth
                        label="شماره موبایل "
                        variant="outlined"
                    />

                    <Button
                        disabled={!isValid || networkState === "PENDING"}
                        fullWidth
                        type="submit"
                        color="primary"
                        style={{color:"#fff"}}
                        variant="contained"
                    >
                        لیست رزرو ها
                    </Button>

                    {networkState === "SUCCEED" && <p>   </p>}
                    {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
                    {networkState === "FAILED" &&
                        (errorMessages.length > 0 ? <p>{errorMessages[0]}</p> : <div>خطایی رخ داده است</div>)}
                </form>

            </Card >
            <ListComponent items={reserveList} refreshList={refreshList} />
        </>
    )
}



